import { customFind } from "../utils/index";
import { dietTagsData } from "../data/dietTagsData";
import testImage from "../img/test-image.png";

// sprawdzić ten import

export const findDietTagImg = (dietTag, path) =>
  customFind("name", dietTag)(dietTagsData)?.imgUrl ??
  ((path && path + testImage) || testImage);
